import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'


Vue.config.productionTip = false

import "../public/css/materialdesignicons.min.css"
import 'swiper/swiper-bundle.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '@mdi/font/css/materialdesignicons.css';
import '@iconscout/unicons/css/line.css';
import 'sweetalert2/dist/sweetalert2.css';

import { BootstrapVue } from 'bootstrap-vue'
var VueScrollTo = require('vue-scrollto')
import Scrollspy from 'vue2-scrollspy'
import VueYoutube from 'vue-youtube'
import vueVimeoPlayer from 'vue-vimeo-player'
import VueMasonry from 'vue-masonry-css'
import Notifications from 'vue-notification'
import VueSweetalert2 from 'vue-sweetalert2';
import VueSignaturePad from 'vue-signature-pad';
import VueMeta from 'vue-meta';

// 텍스트에디터
import '../public/css/_main.scss'

Vue.config.productionTip = false;

Vue.use(VueScrollTo, {
  duration: 3000,
  easing: "ease"
})
Vue.use(BootstrapVue);
Vue.use(Scrollspy);
Vue.use(VueYoutube);
Vue.use(vueVimeoPlayer);
Vue.use(VueMasonry);
Vue.use(Notifications);
Vue.use(VueSweetalert2);
Vue.use(VueSignaturePad);
Vue.use(VueMeta, {
  keyName: 'metaInfo',
  attribute: 'data-vue-meta',
  ssrAttribute: 'data-vue-meta-server-rendered',
  tagIDKeyName: 'vmid',
  refreshOnceOnNavigation: true
});

new Vue({
  router,
  store: store,
  render: h => h(App)
}).$mount('#app')

// Prerendering을 위한 이벤트 발생 (데이터 로딩 완료 후)
if (process.env.NODE_ENV === 'production') {
  // DOM이 완전히 로드된 후 이벤트 발생
  document.addEventListener('DOMContentLoaded', () => {
    // 약간의 지연을 두어 API 호출 완료 대기
    // window.load 이벤트도 확인하여 모든 리소스 로딩 완료 대기
    if (document.readyState === 'complete') {
      setTimeout(() => {
        document.dispatchEvent(new Event('render-event'));
      }, 3000);
    } else {
      window.addEventListener('load', () => {
        setTimeout(() => {
          document.dispatchEvent(new Event('render-event'));
        }, 3000);
      });
    }
  });
}

// 사용자 로그인 상태 확인 부분
const userData = JSON.parse(localStorage.getItem('user'));

if (userData && userData.token && userData.expire && Date.now() < userData.expire) {
  // 사용자가 로그인되어 있고 토큰이 만료되지 않았음
  // 사용자 정보를 저장하거나 다른 작업을 수행할 수 있음
} else {
  // 사용자가 로그인되어 있지 않거나 토큰이 만료됨
  // 세션 로컬 스토리지에서 사용자 데이터를 삭제
  localStorage.removeItem('user');
}

window.onerror = function (msg, url, line, col, error) {
  alert('JS Error: ' + msg + ' @ ' + url + ':' + line);
};

// Chunk 로딩 실패 시 재시도 로직
if (typeof window !== 'undefined') {
  // ChunkLoadError 처리
  window.addEventListener('error', (event) => {
    const target = event.target;
    if (target && (target.tagName === 'SCRIPT' || target.tagName === 'LINK')) {
      const src = target.src || target.href;
      if (src && (src.includes('chunk-') || src.includes('.js') || src.includes('.css'))) {
        console.warn('Chunk 로딩 실패 감지:', src);
        // 페이지 새로고침으로 재시도 (최대 1회)
        if (!window.__chunkRetryAttempted) {
          window.__chunkRetryAttempted = true;
          setTimeout(() => {
            console.log('Chunk 로딩 실패로 인한 페이지 새로고침');
            window.location.reload();
          }, 1000);
        }
      }
    }
  }, true);

  // Promise rejection 처리 (ChunkLoadError)
  window.addEventListener('unhandledrejection', (event) => {
    const error = event.reason;
    if (error && error.message && (
      error.message.includes('Loading chunk') ||
      error.message.includes('ChunkLoadError') ||
      error.name === 'ChunkLoadError'
    )) {
      console.warn('Chunk 로딩 실패 (Promise rejection):', error.message);
      event.preventDefault();
      // 페이지 새로고침으로 재시도 (최대 1회)
      if (!window.__chunkRetryAttempted) {
        window.__chunkRetryAttempted = true;
        setTimeout(() => {
          console.log('Chunk 로딩 실패로 인한 페이지 새로고침');
          window.location.reload();
        }, 1000);
      }
    }
  });
}